import * as React from "react";
import classNames from "classnames";
import { useTheme, atoms } from "@dropbox/dig-foundations";
import * as Icons from "../../icons/sync-manifest";

const css = atoms({ display: "block" });

export interface ArtworkIconProps
  extends React.AriaAttributes,
    React.SVGAttributes<SVGSVGElement> {
  /**
   * The name of the icon to display
   */
  icon: keyof typeof Icons;
  className?: string;
  style?: React.CSSProperties;
  children?: never;
}
export type AvailableIcons = keyof typeof Icons;

/**
 * The Artwork component is simply a proxy to the underlying icon component.
 * It will automatically select the correct icon based on the current color mode detected in context.
 *
 * **Note** This component is not lazy loaded, so it will always load every icon available.
 */
export const ArtworkIcon: React.FC<ArtworkIconProps> = ({
  icon = "Shortcut",
  className,
  ...rest
}) => {
  const { mode } = useTheme();
  /*eslint import/namespace: ['error', { allowComputed: true }]*/
  const ContentIconArtwork = Icons[icon][mode];

  return (
    <ContentIconArtwork className={classNames(className, css)} {...rest} />
  );
};
